import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { buttonLinkTypeNames } from 'common/enums/ButtonLinkEnum'
import React from 'react'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'

import {
  LinkTargetEntityInterface,
  RelEntityInterface,
} from 'src/shared/schemas/buttons/buttons-entities-properties.schema'

type CommonLinkActionButtonEntityInterface = (
  | ActionButtonEntityInterface
  | WebsiteButtonEntityInterface
) &
  Partial<RelEntityInterface & LinkTargetEntityInterface>

export const ButtonLinkActionSettingsLayout = ({
  entity,
  children,
}: SettingsProps<CommonLinkActionButtonEntityInterface> & {
  children: React.ReactNode
}) => {
  const updateProp = useUpdateProp(
    entity as CommonLinkActionButtonEntityInterface,
  )

  const toggleNoFollow = (value: boolean) => {
    let noFollow = ''
    if (value) {
      noFollow = 'nofollow'
    }
    updateProp('rel')(noFollow)
  }

  return (
    <>
      {children}
      <Select
        labelText="open in new window"
        update={updateProp('linkTarget')}
        choiceList={buttonLinkTypeNames}
        value={entity.linkTarget}
      />
      <CheckboxControl
        label="entity_settings.button.no_follow.label"
        tooltipText="entity_settings.button.no_follow.description"
        value={Boolean(entity.rel)}
        update={toggleNoFollow}
      />
    </>
  )
}
